import React from 'react';
import PropTypes from 'prop-types';

// @material-ui
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@material-ui/core';

// core
import { withVisitorInfo } from '_core/utils/visitorInfo';
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { withCatch } from '_core/hocs/withCatch';
import { useCartContext } from '_core/contexts/Cart';
import { State } from '_core/components/State';
import { Title } from '_core/components/Title';
import { renderProp } from '_core/views/StructureInfo';

// style
import { useBriefStatsStyle } from './briefStatsStyle';


const RawBriefStats = (props) => {
  const { visitorInfo, langInfo, getLangString: l } = props
  
  const classes = useBriefStatsStyle()
  
  const [nodeKey, setNodeKey] = React.useState(0)
  
  const cart = useCartContext();

  const {
    request: { queue },
    config: { API_METHOD },
  } = useGlobal()

  const getData = () =>
    queue(API_METHOD.VISITOR_STRUCTURE_INFO, {
      id: visitorInfo.info.id,
      currency: cart.currency.id,
      place: 'stats',
    })

  React.useEffect(() => {
    setNodeKey(nk => nk + 1)
  }, [langInfo, cart.currency])

  return (
    <State
      key={nodeKey}
      getProps={{ data: getData }}
      render={({ data }) => {
        if (!data.props?.length)
          return null;

        return (
          <div className={classes.root}>
            <Title icon="equalizer" children={l('r._.stats.text.title')} />

            <Grid container={true}>
              {data.props.map((prop, index) => (
                <Grid
                  key={index}
                  item={true}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  className={classes.column}
                >
                  <Card elevation={12} className={classes.card}>
                    <CardHeader
                      className={classes.label}
                      subheader={prop.title}
                    />
                    <CardContent className={classes.content}>
                      <Typography variant="h6" className={classes.value}>
                        {renderProp(l, prop)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        )
      }}
    />
  )
}

RawBriefStats.defaultProps = {}

RawBriefStats.propTypes = {
  // withVisitorInfo
  visitorInfo: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const BriefStats = withVisitorInfo(withCatch(withLang(RawBriefStats)))
